export default __webpack_public_path__ + "static/media/headmade-logo.01c5ca15.svg";